import { FormEvent, FormEventHandler, FocusEventHandler } from 'react';
import { Dispatch } from 'redux';

export function getPayload(event: FormEvent, trimValue: boolean = false) {
  const {
    name,
    value,
    type,
    checked = false,
  } = event.target as HTMLInputElement;

  const isCheckbox = type === 'checkbox';
  const fieldName = name.replace(/^\w+\//, '');

  return isCheckbox
    ? { [fieldName]: { value, checked, error: false } }
    : {
        [fieldName]: { value: trimValue ? value.trim() : value, error: false },
      };
}

export function getOnChange(
  namespace: string,
  dispatch: Dispatch,
  additionalParams = {}
): FormEventHandler {
  return function (event: FormEvent) {
    const payload = getPayload(event);
    dispatch({
      type: `${namespace}/onChange`,
      payload,
      ...additionalParams,
    });
  };
}

export function trimOnBlur(
  namespace: string,
  dispatch: Dispatch,
  additionalParams = {}
): FocusEventHandler {
  return function (event: FormEvent) {
    const { name, value } = event.target as HTMLInputElement;
    const trimmedValue = value.trim();
    const payload = { [name]: { value: trimmedValue, error: false } };

    const action = namespace.includes('secondParent') ? 'change' : 'onChange';

    dispatch({
      type: `${namespace}/${action}`,
      payload,
      ...additionalParams,
    });
    if (!namespace.includes('child')) {
      dispatch({ type: 'form/saveDraft' });
    }
  };
}

export function isNameChangedToggle(
  namespace: string,
  dispatch: Dispatch,
  additionalParams = {}
): FormEventHandler {
  return function (event: FormEvent) {
    const payload = getPayload(event);
    dispatch({
      type: `${namespace}/isNameChanged/toggle`,
      payload,
      ...additionalParams,
    });
  };
}

export function getOnBlur(
  namespace: string,
  dispatch: Dispatch
): FormEventHandler {
  return function (event: FormEvent) {
    const { name, value } = event.target as HTMLInputElement;
    dispatch({
      type: `${namespace}/validate/field`,
      payload: { namespace, name, value },
    });
  };
}

export function getOnCitizenshipChange(
  namespace,
  dispatch,
  additionalParams = {}
) {
  return function ({ value: payload }) {
    dispatch({
      type: `${namespace}/citizenship/set/value`,
      payload,
      ...additionalParams,
    });
    dispatch({
      type: `${namespace}/citizenship/validate`,
      payload,
      ...additionalParams,
    });
  };
}

export function onSecondParentChange(
  dispatch: Dispatch,
  additionalParams = {}
): FormEventHandler {
  return function (event: FormEvent) {
    const payload = getPayload(event);

    dispatch({
      type: 'child/secondParent/change',
      payload,
      ...additionalParams,
    });
  };
}

export const setErrorToRelativeFields = (
  dispatch: Dispatch,
  namespace,
  fields,
  error = false
) =>
  dispatch({
    type: `${namespace}/set/error/relativeFields`,
    payload: {
      fields,
      error,
    },
  });

export const setErrorToSecondParentRelativeFields = (
  dispatch: Dispatch,
  namespace,
  fields,
  error = false
) =>
  dispatch({
    type: `${namespace}/secondParent/set/error/relativeFields`,
    payload: {
      fields,
      error,
    },
  });
